import { api, type ApiResponse } from '../utils';
import type {
  GetAgentReviewCountsData,
  GetAgentReviewsData,
} from '../types/agentReview';

const getAgentReviews = async (
  data: GetAgentReviewsData
): Promise<ApiResponse> => {
  let endpoint = '/dashboard/agent-review-matches';

  const { page, limit = 20, status, start_date, end_date } = data;

  const params: Record<string, string> = {
    page: page.toString(),
    limit: limit.toString(),
    status,
    agent: '1',
  };

  // Add optional filters only if they have values
  if (start_date) params.start_date = start_date;
  if (end_date) params.end_date = end_date;

  const queryString = new URLSearchParams(params).toString();

  endpoint += `?${queryString}`;

  const { data: response } = await api.get(endpoint);
  return response;
};

const getAgentReviewCounts = async (
  data: GetAgentReviewCountsData
): Promise<ApiResponse> => {
  let endpoint: string = '/dashboard/agent-review-matches-count';
  const { start_date, end_date } = data;

  if (start_date && end_date) {
    const params: Record<string, string> = {
      start_date,
      end_date,
      agent: '1',
    };
    const queryString = new URLSearchParams(params).toString();
    endpoint += `?${queryString}`;
  }

  const { data: response } = await api.get(endpoint);
  return response;
};

export { getAgentReviews, getAgentReviewCounts };
